module.exports = __webpack_public_path__ + "img/semPermissao.ce8277b5.svg";